export enum EnumTpSincronizacao {
    Automatica = '0',
    AutomaticaComTemporizador = '1',
    Manual = '2'
}